var clamp_default = (_o, c, d) => {
  c.prototype.clamp = function(min, max, unit) {
    const dMin = min instanceof c ? min : d(min);
    const dMax = max instanceof c ? max : d(max);
    if (min && this.isBefore(dMin, unit))
      return dMin;
    if (max && this.isAfter(dMax, unit))
      return dMax;
    return this;
  };
};
export {
  clamp_default as default
};
